import { KoForeach } from "@/index"

/**
 * @deprecated Use `KoForeach` instead. This component will be removed in a future version.
 */
export const KoForeachComment = KoForeach
